import {
  FETCH_COACHDASHBOARD_REQUEST,
  FETCH_COACHDASHBOARD_SUCCESS,
  FETCH_COACHDASHBOARD_FAILURE,
} from './coachDashboardTypes';

const initialState = {
  loading: false,
  coachDashboard: null,
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COACHDASHBOARD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COACHDASHBOARD_SUCCESS:
      return {
        loading: false,
        coachDashboard: action.payload,
        error: '',
      };
    case FETCH_COACHDASHBOARD_FAILURE:
      return {
        loading: false,
        coachDashboard: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
